import {_getAppConfig} from './config.mjs';

const APP_CONFIG = _getAppConfig();

export {APP_CONFIG};
